import { Box, Typography } from "@material-ui/core"
import { drillDownStyles } from "../../../../styles"
import { ReactNode } from "react"

export function ExpandedLayoutTitleWithActions({
  children,
  title,
}: {
  children: ReactNode
  title: string
}) {
  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        width="100%"
        alignItems="center"
        marginBottom="42px"
      >
        <Typography align="left" className={drillDownStyles.chartTitle}>
          {title}
        </Typography>
        {children}
      </Box>
    </>
  )
}
